import { SecondaryButton } from 'ui/button';
import { LeftTooltip } from 'ui/tooltip';
import { isUndefined } from 'utils/tsHelpers';
import { sentenceCase } from 'utils/stringHelpers';
import { useTranslation } from '../../../hooks/useTranslation';
import {
  useHasMaximumConditions,
  useClauseCombinatorWatch,
  useAddCondition,
} from '../../../hooks/form';

export const DATA_TEST = {
  button: 'combinator-add-button',
};

export const AddConditionButton = () => {
  const { t } = useTranslation();
  const addCondition = useAddCondition();
  const hasMaxConditions = useHasMaximumConditions();
  const combinator = useClauseCombinatorWatch();

  if (isUndefined(combinator)) return null;

  return (
    <LeftTooltip isEnabled={hasMaxConditions} tooltipContent={t('selector.combinatorAddTooltip')}>
      <SecondaryButton
        onClick={addCondition}
        isDisabled={hasMaxConditions}
        data-test={DATA_TEST.button}
      >
        {sentenceCase(combinator)}
      </SecondaryButton>
    </LeftTooltip>
  );
};
